import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../AppClient";
function CustomerScreen() {
  const { id } = useParams();
  const [CustomerData, setCustomerData] = useState({
    name: "",
    phone: "",
    customer_type: "",
    last_purchase_date: "",
    total_purchase_value: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchCustomer();
  }, []);

  const fetchCustomer = async () => {
    setLoading(true);
    apiClient
      .get(`/customers/${id}/`)
      .then((response) => {
        setCustomerData(response.data);
        setError(null);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
    setLoading(false);
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">تفاصيل الزبون</h2>
      <div className="card shadow">
        <div className="card-header bg-success text-white">
          <h4 className="mb-0">
            {CustomerData.name || "اسم الزبون غير متوفر"}
          </h4>
        </div>
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-6">
              <strong>اسم الزبون:</strong>
              <p className="text-muted">{CustomerData.name || "غير متوفر"}</p>
            </div>
            <div className="col-md-6">
              <strong>رقم الهاتف:</strong>
              <p className="text-muted">{CustomerData.phone || "غير متوفر"}</p>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-6">
              <strong>نوع الزبون:</strong>
              <p className="text-muted">
                {CustomerData.customer_type || "غير متوفر"}
              </p>
            </div>
            <div className="col-md-6">
              <strong>الرصيد المتبقي:</strong>
              <p className="text-muted">
                {CustomerData.remaining_balance || "غير متوفر"}
              </p>
            </div>
            <div className="col-md-6">
              <strong>تاريخ اخر عملية شراء:</strong>
              <p className="text-muted">
                {CustomerData.last_purchase_date || "غير متوفر"}
              </p>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-6">
              <strong>مجموع قيمة المشتريات:</strong>
              <p className="text-muted">
                {CustomerData.total_purchase_value
                  ? `${CustomerData.total_purchase_value} جنيه`
                  : "غير متوفر"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerScreen;
